import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import type { SocialProvider } from '@nucleus-commerce/api-client/admin';

/** Store-scoped keys: switching stores never shares cache. */
export const socialKeys = {
  all: (storeId: string) => ['stores', storeId, 'social'] as const,
  connections: (storeId: string) => [...socialKeys.all(storeId), 'connections'] as const,
  analytics: (storeId: string, range: { from: string; to: string }) =>
    [...socialKeys.all(storeId), 'analytics', range.from, range.to] as const,
  catalog: (storeId: string, provider: SocialProvider) =>
    [...socialKeys.all(storeId), 'catalog', provider] as const,
  adAccounts: (storeId: string, provider: SocialProvider) =>
    [...socialKeys.all(storeId), 'ad-accounts', provider] as const,
  targets: (storeId: string, provider: SocialProvider) =>
    [...socialKeys.all(storeId), 'targets', provider] as const,
  posts: (storeId: string) => [...socialKeys.all(storeId), 'posts'] as const,
  postLists: (storeId: string) => [...socialKeys.posts(storeId), 'list'] as const,
  postList: (storeId: string, params: ListParams) =>
    [...socialKeys.postLists(storeId), params] as const,
  post: (storeId: string, id: string) => [...socialKeys.posts(storeId), 'detail', id] as const,
  /** The master product gallery is organisation-level; the key is not store-scoped. */
  productMedia: (productId: string) => ['social', 'product-media', productId] as const,
};
